import { api } from "./configs/axiosConfigs";

export const MaintenanceTypeAPI = {
    get: async (data?: any) => {
        const response = await api
            .get('/typeExternalMaintenance', { params: { ...data } })
            .then(response => response.data)
            .catch((error) => {
                return error.response.data
            });
        return response;
    },
    create: async (data: any) => {
        const response = await api
            .post("/typeExternalMaintenance/register", { ...data })
            .then((response) => response.data)
            .catch((error) => {
                console.error(error);
                return error.response.data;
            });
        return response;
    },

    edit: async (id: number, data: any) => {
        const response = await api
            .patch(`/typeExternalMaintenance/${id}`, { ...data })
            .then((response) => response.data)
            .catch((error) => {
                console.error(error);
                return error.response.data;
            });
        return response;
    },

    delete: async (id: number) => {
        const response = await api
            .delete(`/typeExternalMaintenance/${id}`)
            .then((response) => response.data)
            .catch((error) => {
                return error.response.data;
            });
        return response;
    },
}